import paths from "@ingka/icons-shared/paths/double-doors";
import { renderPaths } from "../renderPaths.mjs";
var double_doors_default = () => renderPaths(paths);
export {
  double_doors_default as default
};
